import React, { useEffect, useState } from 'react'
import CreatePaymentMethod from '../../components/payment/CreatePaymentMethod'
import PaymentMethodList from '../../components/payment/PaymentMethodList'
import { useFetch, usePost, useCurrent, useDelete, usePut } from '../../hooks';
import { MwSpinner, ConfirmDelete } from '../../components/ui';
import UpdatePaymentMethod from '../../components/payment/UpdatePaymentMethod';

import { useTranslation } from 'react-i18next';

const PurchasesPaymentMethodSettings = ({ apiBaseUrl, financeApiBaseUrl }) => {
    const [t] = useTranslation('global');
    const { currentTenantId, currentCompanyId, currentBranchId, userId, currentLangList, currentLangId } = useCurrent()
    const baseUrlRaw = (apiBaseUrl || process.env.REACT_APP_INV_API_SERVER_BASE_URL || "").replace(/\/+$/, "");
    const baseUrl = baseUrlRaw.replace(/\/sales(\/|$)/i, "/purchases$1");
    const buildUrl = (path) => baseUrl ? `${baseUrl}/${String(path || "").replace(/^\/+/, "")}` : null;
    const canFetchContext = Boolean(currentTenantId && currentCompanyId && currentBranchId);
    const { data: paymentMethods, loading, refreshHandler } = useFetch(
        canFetchContext ? buildUrl(`payment-methods/${currentTenantId}/${currentCompanyId}/${currentBranchId}`) : null
    )
    const { data: dataCreate, loading: loadingCreate, postData: postCreate } = usePost();
    const { data: dataUpdate, loading: loadingUpdate, putData } = usePut();
    const [itemSelected, setItemSelected] = useState({});
    const { deleteItem, loading: loadingDelete } = useDelete();
    const [isConfirmDelete, setIsConfirmDelete] = useState(false);
    const [mode, setMode] = useState('Adding');

    useEffect(() => {
        if (!loadingUpdate && (dataCreate || dataUpdate || loadingDelete)) {
            refreshHandler();
            setMode('Adding');
        }
    }, [dataCreate, dataUpdate, loadingDelete, loadingUpdate]);

    const confirmDeleteHandler = (item) => {
        setItemSelected(item)
        setIsConfirmDelete(true)
    }

    const deleteHandler = () => {
        const id = itemSelected?.id;
        deleteItem(buildUrl(`payment-methods/delete/${id}`));
    }

    const editHandler = (item) => {
        setItemSelected(item)
        setMode('Editing')
    }

    useEffect(() => {
        if (!loadingDelete && isConfirmDelete) {
            setIsConfirmDelete(false);
        }
    }, [loadingDelete, isConfirmDelete]);

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">{t('settings.paymentMethodSettings')}</h1>
            </div>
            <ConfirmDelete
                onShow={isConfirmDelete}
                setOnShow={setIsConfirmDelete}
                title={`Deleting...`}
                msg={`Are you sure you want to delete`}
                onDeleteHandler={deleteHandler}
                loading={loadingDelete}
            />
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-1 bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    {mode === 'Adding' ? <CreatePaymentMethod
                        currentLangList={currentLangList}
                        currentTenantId={currentTenantId}
                        currentCompanyId={currentCompanyId}
                        currentBranchId={currentBranchId}
                        currentLangId={currentLangId}
                        userId={userId}
                        data={dataCreate}
                        loading={loadingCreate}
                        postData={postCreate}
                        apiBaseUrl={baseUrl}
                        showTreasury={true}
                        financeApiBaseUrl={financeApiBaseUrl}
                    /> : <UpdatePaymentMethod
                        currentLangList={currentLangList}
                        currentTenantId={currentTenantId}
                        currentCompanyId={currentCompanyId}
                        currentBranchId={currentBranchId}
                        currentLangId={currentLangId}
                        userId={userId}
                        currentItem={itemSelected}
                        data={dataUpdate}
                        loading={loadingUpdate}
                        putData={putData}
                        apiBaseUrl={baseUrl}
                        showTreasury={true}
                        financeApiBaseUrl={financeApiBaseUrl}
                    />
                    }
                </div>
                <div className="lg:col-span-2">
                    {!!paymentMethods ? <PaymentMethodList
                        confirmDeleteHandler={confirmDeleteHandler}
                        editHandler={editHandler}
                        data={paymentMethods}
                        loading={loading}
                        currentLangId={currentLangId}
                        apiBaseUrl={baseUrl}
                    /> : <div className='h-40 bg-white p-6 rounded-lg shadow-sm border border-gray-200 flex items-center justify-center'> <MwSpinner hightScreen={false} />  </div>}
                </div>
            </div>
        </div>
    )
}

export default PurchasesPaymentMethodSettings
